document.documentElement.style.setProperty(
  "--header-height",
  `${document
    .getElementById("shopify-section-{{ section.id }}")
    .clientHeight.toFixed(2)}px`
);

(function () {
  const mobileMenuToggle = document.getElementById(
    "mobile-menu-toggle-{{ section.id }}"
  );
  const sidebarMenu = document.getElementById("sidebar-menu");

  if (mobileMenuToggle && sidebarMenu) {
    mobileMenuToggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen =
        sidebarMenu.hasAttribute("open") || sidebarMenu.open === true;

      if (isOpen) {
        if (typeof sidebarMenu.close === "function") {
          sidebarMenu.close();
        } else {
          sidebarMenu.removeAttribute("open");
        }
      } else {
        if (typeof sidebarMenu.show === "function") {
          sidebarMenu.show();
        } else {
          sidebarMenu.setAttribute("open", "");
        }
      }
    });
  }
})();

/**
 * Wishlist app block: ensure count badge shows only the number (no parentheses).
 * e.g. "(2)" -> "2"
 */
function stripWishlistCountParentheses() {
  const header = document.querySelector(".header");
  if (!header) return;

  const countSelectors = [
    ".wishlist-hero-items-count",
    "[class*='wishlist-hero-items-count']",
    "[class*='count'][class*='badge']",
    "[class*='count'][class*='bubble']",
  ];

  header.querySelectorAll(".header__app-block").forEach(function (block) {
    countSelectors.forEach(function (sel) {
      try {
        block.querySelectorAll(sel).forEach(function (el) {
          var text = (el.textContent || "").trim();
          var match = text.match(/^\((\d+)\)$/);
          if (match) {
            el.textContent = match[1];
          } else if (text.indexOf("(") !== -1 && text.indexOf(")") !== -1) {
            el.textContent = text.replace(/\s*\((\d+)\)\s*/, "$1").trim();
          }
        });
      } catch (e) {}
    });
  });
}

/**
 * Wishlist app block: add label under icon (like cart) if not already in section.
 * Label is normally added in Liquid as .header__app-block-label; this runs for apps that render before that.
 */
function injectWishlistTextInAppBlocks() {
  const header = document.querySelector(".header");
  if (!header) return;

  const label =
    header.getAttribute("data-wishlist-label") ||
    (header.closest(".shopify-section") && header.closest(".shopify-section").getAttribute("data-wishlist-label")) ||
    "Wishlist";

  const appBlocks = header.querySelectorAll(".header__app-block");
  appBlocks.forEach(function (block) {
    if (block.querySelector(".header__app-block-label")) return;
    const link = block.querySelector("a");
    if (!link || link.querySelector(".header__utility-text")) return;

    const span = document.createElement("span");
    span.className = "header__utility-text header__app-block-label";
    span.textContent = label;
    link.appendChild(span);
  });

  stripWishlistCountParentheses();
}

function runHeaderAppBlockUpdates() {
  injectWishlistTextInAppBlocks();
  stripWishlistCountParentheses();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runHeaderAppBlockUpdates);
} else {
  runHeaderAppBlockUpdates();
}

// Re-run when wishlist app updates the count dynamically
if (typeof MutationObserver !== "undefined") {
  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".header");
    if (!header) return;
    const observer = new MutationObserver(function () {
      stripWishlistCountParentheses();
    });
    header.querySelectorAll(".header__app-block").forEach(function (block) {
      observer.observe(block, { childList: true, subtree: true, characterData: true });
    });
  });
}
